/** Capacity outside scheduled sleep, independent of heartbeat coverage. Today is elapsed so far. */
export function expectedUptimeHoursForDay(row: {
  scheduledHours: number;
  capacityHours: number;
}): number {
  return Math.max(0, row.capacityHours - row.scheduledHours);
}
